import { useMutation } from "@tanstack/react-query";
import { api } from "../api/client.ts";
import { useAuth } from "../auth/AuthProvider.tsx";
import { toast } from "./feedback.tsx";

/**
 * "Send me a test", where the email is being written or scheduled: the saved
 * template rendered as recipients will get it (your details in the merge
 * fields), to your own inbox, from the campaign's sender when there is one.
 */
export function TestSendButton({
  templateId,
  senderId,
  disabled,
}: {
  templateId: string;
  senderId?: string | undefined;
  disabled?: boolean | undefined;
}) {
  const { user } = useAuth();
  const send = useMutation({
    mutationFn: () =>
      api.post<{ to: string[]; from: string }>("/test-send/template", {
        templateId,
        ...(senderId ? { senderId } : {}),
      }),
    onSuccess: (res) => toast(`Test sent to ${res.to.join(", ")} from ${res.from}`),
    onError: (err: Error) => toast(err.message, "bad"),
  });
  return (
    <button
      type="button"
      className="btn ghost small"
      disabled={disabled || send.isPending}
      title={user ? `Sends to ${user.email}` : undefined}
      onClick={() => send.mutate()}
    >
      {send.isPending ? "Sending test…" : "Send me a test"}
    </button>
  );
}
